import {fetchUser, fetchUserDetails} from "./api";
import {clearServicePoints} from "./spActions";

export const SET_LANGUAGE = "SET_LANGUAGE"
export const SET_TOKEN = "SET_TOKEN"
export const LOGOUT = "LOGOUT"
export const CREATE_PENDING_REGISTRATION = "CREATE_PENDING_REGISTRATION"
export const CLEAR_PENDING_REGISTRATION = "CLEAR_PENDING_REGISTRATION"
export const UPDATE_USER_DETAILS = "UPDATE_USER_DETAILS"
export const SET_USER_DETAILS_LOADED = "SET_USER_DETAILS_LOADED"

export function setLanguage(languageCode) {
    return {
        type: SET_LANGUAGE,
        languageCode
    }
}

export function setToken(token) {
    return {
        type: SET_TOKEN,
        token
    }
}

export function logout() {
    return function(dispatch) {
        dispatch(logoutAction())
        dispatch(clearServicePoints())
    }
}

function logoutAction() {
    return {
        type: LOGOUT
    }
}

export function createPendingRegistration(email, customerType) {
    return {
        type: CREATE_PENDING_REGISTRATION,
        email,
        customerType
    }
}

export function clearPendingRegistration() {
    return {
        type: CLEAR_PENDING_REGISTRATION
    }
}

export function requestUser() {
    return function (dispatch, getState) {
        const token = getState().user.token;
        if (!token) {
            return Promise.reject()
        }

        fetchUser(token)
            .then(response => {
                if (!response.ok) {
                    throw new Error("Response is not OK")
                }
                return response
            })
            .then(response => response.json())
            .then(user => {
                dispatch(updateUserDetails({name: user.name, isAdmin: user.admin}))
            })
    }
}

export function requestUserDetails() {
    return function (dispatch, getState) {
        const token = getState().user.token;
        if (!token) {
            return Promise.reject()
        }

        fetchUserDetails(token)
            .then(response => {
                if (!response.ok) {
                    throw new Error("Response is not OK")
                }
                return response
            })
            .then(response => response.json())
            .then(userDetails => {
                const details = {
                    name: userDetails.name,
                    phones: userDetails.phones,
                    ids: userDetails.ids,
                    isAdmin: userDetails.admin
                }
                dispatch(updateUserDetails(details))
                dispatch(setDetailsLoaded())
            })
    }
}

export function updateUserDetails(details) {
    return {
        type: UPDATE_USER_DETAILS,
        details
    }
}

function setDetailsLoaded() {
    return {
        type: SET_USER_DETAILS_LOADED
    }
}
